// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { pgn as _pgn } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the pgn chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 424
 * Chain Name: PGN
 * Default Block Explorer: https://explorer.publicgoods.network
 * Default RPC URL: https://rpc.publicgoods.network
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { pgn } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: pgn,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const pgn = createCommon({
	..._pgn,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
